
import React from 'react';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { Box } from 'grommet';

import CellLink from './CellLink';
import CellTitle from './CellTitle';
import DataTable from './DataTable';
import OdrudyFilter from './odruda/OdrudyFilter';

function getColumns() {
    return [
        {
            property: 'nazev',
            header: <CellTitle title="Název" />,
            render: row => (
                <CellLink size="medium" title={row.nazev} link={`odruda/${row.id}`} />
            ),
            search: false,
            sortable: false
        },
        {
            property: 'nazev_lidovy',
            header: <CellTitle title="Lidový název" />,
            search: false,
            sortable: false
        }
    ];
}

const OdrudaList = ({odrudaList, odrudaFilter, onFilterChange, history}) => {
    return (
        <Box>
            <OdrudyFilter
                attributes={odrudaFilter}
                onChange={onFilterChange}
            />
            <DataTable
                columns={getColumns()}
                data={odrudaList}
                sortable={true}
                primaryKey="id"
            />
        </Box>
    );
}

export default withTheme(withRouter(OdrudaList));
